export const obtenerValorReservaTotal = ({numNoches, numDiasPromo=0, habitacion}) =>{

    let valor = parseInt(habitacion.tarifa)
    let valorPromo = parseInt(habitacion.valorPromo ? habitacion.valorPromo : 0)
    let diasNormal = numNoches - numDiasPromo

    return (valor * diasNormal) + (valorPromo * numDiasPromo)

}